export const serviceName = 'contracts'

export default {
  serviceName
}
